import { render, staticRenderFns } from "./OutreachInvoiceView.vue?vue&type=template&id=10fb60af&"
import script from "./OutreachInvoiceView.vue?vue&type=script&lang=js&"
export * from "./OutreachInvoiceView.vue?vue&type=script&lang=js&"
import style0 from "./OutreachInvoiceView.vue?vue&type=style&index=0&id=10fb60af&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports